import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IFrameMessageService} from '@app/services/iframe/iframe-message.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CLOSE_EVENT} from '@dcp/configurator';

@UntilDestroy()
@Component({
  selector: 'dcp-iframe-close-icon',
  templateUrl: './iframe-close-icon.component.html',
  styleUrls: ['./iframe-close-icon.component.scss']
})
export class IframeCloseIconComponent implements OnInit, AfterViewInit, OnDestroy {

  modeSubscription: Subscription = Subscription.EMPTY;
  modalMode: boolean = false;
  displayMode: string;

  @ViewChild('closeButton', {static: false}) closeButton: ElementRef;

  constructor(
    private iframeMessageService: IFrameMessageService,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.modeSubscription = this.activatedRoute.queryParamMap.pipe(untilDestroyed(this)).subscribe((value) => {
      this.displayMode = value.get('displayMode');
      this.modalMode = !!this.displayMode && this.displayMode === 'modal';
    });
  }

  ngAfterViewInit() {
    if (this.closeButton?.nativeElement) {
      this.closeButton.nativeElement.focus();
    }
  }

  ngOnDestroy() {
    this.modeSubscription.unsubscribe();
  }

  @HostListener('document:keydown.escape')
  sendCloseEvent(): void {
    this.iframeMessageService.postMessage({eventId: CLOSE_EVENT});
  }
}
